module.exports = __webpack_public_path__ + "static/img/tese-img4.6f1acbf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/tese-img4.png
// module id = 934
// module chunks = 0